import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    defaultActive:null,//当前激活的菜单
  },
  getters: {
  },
  mutations: {
    setDefaultActive(state,value){
      state.defaultActive = value
    }
  },
  actions: {
  },
  modules: {
  }
})
